import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
const orders = [{
  orderNum: '12251',
  status: 'Processed',
  transNum: '12251',
  qty: 1,
  product: 'Broker Management Clinic',
  price: '$19.95',
  total: '$19.95',
  date: '05/31/2012'
}, {
  orderNum: '12263',
  status: 'Processed',
  transNum: '12263',
  qty: 1,
  product: '',
  price: '$0.00',
  total: '$89.95',
  date: '06/02/2012'
}, {
  orderNum: '12789',
  status: 'Processed',
  transNum: '12789',
  qty: 1,
  product: 'Arizona Water Law',
  price: '$0.00',
  total: '$14.95',
  date: '08/29/2012'
}, {
  orderNum: '15561',
  status: 'Processed',
  transNum: '15561',
  qty: 1,
  product: 'Broker Management Clinic #1 Residential-Statutes and Rules',
  price: '$19.95',
  total: '$0.00',
  date: '02/10/2013'
}, {
  orderNum: '15563',
  status: 'Processed',
  transNum: '15563',
  qty: 1,
  product: 'Broker Management Clinic #2 Residential-Broker Policies',
  price: '$19.95',
  total: '$0.00',
  date: '03/10/2013'
}, {
  orderNum: '15567',
  status: 'Processed',
  transNum: '15567',
  qty: 1,
  product: 'Broker Management Clinic #1 Residential-Statutes and Rules',
  price: '$19.95',
  total: '$24.95',
  date: '02/10/2013'
}, {
  orderNum: '15579',
  status: 'Processed',
  transNum: '15579',
  qty: 1,
  product: '',
  price: '$0.00',
  total: '$0.00',
  date: '02/12/2013'
}, {
  orderNum: '15607',
  status: 'Processed',
  transNum: '15607',
  qty: 1,
  product: 'Broker Management Clinic #3 Residential-Broker Supervision',
  price: '$19.95',
  total: '$0.00',
  date: '03/14/2013'
}, {
  orderNum: '15789',
  status: 'Processed',
  transNum: '15789',
  qty: 1,
  product: 'Agents & Agency',
  price: '$19.95',
  total: '$0.00',
  date: '02/27/2013'
}, {
  orderNum: '18351',
  status: 'Processed',
  transNum: '18351',
  qty: 1,
  product: '',
  price: '$0.00',
  total: '$0.00',
  date: '02/23/2014'
}, {
  orderNum: '18627',
  status: 'Processed',
  transNum: '18627',
  qty: 1,
  product: 'Agents & Agency',
  price: '$19.95',
  total: '$0.00',
  date: '04/04/2014'
}, {
  orderNum: '19640',
  status: 'Processed',
  transNum: '19640',
  qty: 1,
  product: 'Fair Housing Facts',
  price: '$19.95',
  total: '$0.00',
  date: '10/16/2014'
}, {
  orderNum: '19719',
  status: 'Processed',
  transNum: '19719',
  qty: 1,
  product: "Don't Lose Your License",
  price: '$19.95',
  total: '$1.00',
  date: '10/31/2014'
}, {
  orderNum: '19720',
  status: 'Processed',
  transNum: '19720',
  qty: 1,
  product: "Don't Hide the Facts",
  price: '$19.95',
  total: '$1.00',
  date: '10/31/2014'
}, {
  orderNum: '22417',
  status: 'Processed',
  transNum: '22417',
  qty: 1,
  product: 'NAR Code of Ethics (NO CE CREDIT)',
  price: '$14.95',
  total: '$0.00',
  date: '10/14/2016'
}, {
  orderNum: '27081',
  status: 'Processed',
  transNum: '27081',
  qty: 1,
  product: 'Who Do You Represent?',
  price: '$19.95',
  total: '$0.00',
  date: '09/10/2017'
}, {
  orderNum: '29496',
  status: 'Processed',
  transNum: '29496',
  qty: 1,
  product: 'Fair Housing for All',
  price: '$19.95',
  total: '$0.00',
  date: '08/19/2018'
}, {
  orderNum: '29908',
  status: 'Processed',
  transNum: '29908',
  qty: 1,
  product: 'The Law & the Licensee',
  price: '$19.95',
  total: '$0.00',
  date: '10/14/2018'
}, {
  orderNum: '35498',
  status: 'Processed',
  transNum: '35498',
  qty: 1,
  product: 'How Contracts Work',
  price: '$19.95',
  total: '$0.00',
  date: '02/24/2020'
}, {
  orderNum: '35687',
  status: 'Processed',
  transNum: '35687',
  qty: 1,
  product: 'Agents & Agency',
  price: '$19.95',
  total: '$18.95',
  date: '03/10/2020'
}, {
  orderNum: '40054',
  status: 'Processed',
  transNum: '40054',
  qty: 1,
  product: 'Broker Management Clinic #3 Residential-Broker Supervision',
  price: '$19.95',
  total: '$0.00',
  date: '10/08/2020'
}, {
  orderNum: '46927',
  status: 'Processed',
  transNum: '46927',
  qty: 1,
  product: 'NAR Code of Ethics (NO CE CREDIT)',
  price: '$14.95',
  total: '$0.00',
  date: '01/30/2022'
}, {
  orderNum: '47248',
  status: 'Processed',
  transNum: '47248',
  qty: 1,
  product: 'The Code and the Commissioner (with NAR Code of Ethics)',
  price: '$19.95',
  total: '$19.95',
  date: '02/20/2022'
}, {
  orderNum: '48756',
  status: 'Processed',
  transNum: '48756',
  qty: 1,
  product: '#1 8-Class Salesperson Renewal Package (Preset 24 hours)',
  price: '$89.95',
  total: '$0.00',
  date: '08/02/2022'
}, {
  orderNum: '52762',
  status: 'Processed',
  transNum: '52762',
  qty: 1,
  product: '3-Class Renewal Package (select your own courses-9 hours)',
  price: '$49.95',
  total: '$64.90',
  date: '02/20/2023'
}, {
  orderNum: '52762',
  status: 'Failed',
  transNum: '52762',
  qty: 1,
  product: 'NAR Code of Ethics (NO CE CREDIT)',
  price: '$14.95',
  total: '$64.90',
  date: '02/20/2023'
}, {
  orderNum: '52954',
  status: 'Processed',
  transNum: '52954',
  qty: 1,
  product: '#2 8-Class Salesperson Renewal Package (Preset 24 hours with NAR Ethics)',
  price: '$89.95',
  total: '$0.00',
  date: '03/03/2023'
}, {
  orderNum: '59312',
  status: 'Processed',
  transNum: '59312',
  qty: 1,
  product: 'They Are A Protected Class',
  price: '$19.95',
  total: '$0.00',
  date: '05/08/2024'
}, {
  orderNum: '59715',
  status: 'Processed',
  transNum: '59715',
  qty: 1,
  product: 'The Code and the Commissioner (with NAR Code of Ethics)',
  price: '$19.95',
  total: '$13.97',
  date: '06/05/2024'
}, {
  orderNum: '59735',
  status: 'Processed',
  transNum: '59735',
  qty: 1,
  product: 'Ethics & The Rules (with NAR Code of Ethics)',
  price: '$19.95',
  total: '$0.00',
  date: '06/06/2024'
}, {
  orderNum: '60952',
  status: 'Processed',
  transNum: '60952',
  qty: 1,
  product: 'Follow All The Laws',
  price: '$19.95',
  total: '$0.00',
  date: '08/13/2024'
}, {
  orderNum: '60960',
  status: 'Processed',
  transNum: '60960',
  qty: 1,
  product: 'What Goes Wrong In Contracts',
  price: '$19.95',
  total: '$0.00',
  date: '08/13/2024'
}, {
  orderNum: '61520',
  status: 'Processed',
  transNum: '61520',
  qty: 1,
  product: 'Deeds, Fires & Water: Be Prepared',
  price: '$19.95',
  total: '$0.00',
  date: '09/14/2024'
}, {
  orderNum: '64551',
  status: 'Processed',
  transNum: '64551',
  qty: 1,
  product: 'Are They Represented?',
  price: '$19.95',
  total: '$0.00',
  date: '02/20/2025'
}, {
  orderNum: '66016',
  status: 'Processed',
  transNum: '66016',
  qty: 1,
  product: 'Client or Customer Representation',
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66017',
  status: 'Processed',
  transNum: '66017',
  qty: 1,
  product: 'A Letter From ADRE',
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66018',
  status: 'Processed',
  transNum: '66018',
  qty: 1,
  product: "Don't Lose Your License",
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66019',
  status: 'Processed',
  transNum: '66019',
  qty: 1,
  product: 'BMC #1 AZ Residential-Statutes and Rules',
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66020',
  status: 'Processed',
  transNum: '66020',
  qty: 1,
  product: 'BMC #2 AZ Residential-Broker Policies',
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66021',
  status: 'Processed',
  transNum: '66021',
  qty: 1,
  product: 'BMC #3 AZ Residential-Broker Supervision',
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66022',
  status: 'Processed',
  transNum: '66022',
  qty: 1,
  product: 'Accidental Property Management',
  price: '$19.95',
  total: '$0.00',
  date: '05/10/2025'
}, {
  orderNum: '66032',
  status: 'Processed',
  transNum: '66032',
  qty: 1,
  product: 'Deeds, Fires & Water: Be Prepared',
  price: '$19.95',
  total: '$0.00',
  date: '05/12/2025'
}, {
  orderNum: '66713',
  status: 'Processed',
  transNum: '66713',
  qty: 1,
  product: 'Ethics & The Rules (with NAR Code of Ethics)',
  price: '$19.95',
  total: '$0.00',
  date: '06/22/2025'
}, {
  orderNum: '66867',
  status: 'Processed',
  transNum: '66867',
  qty: 1,
  product: 'BMC #3B Property Management',
  price: '$19.95',
  total: '$0.00',
  date: '07/02/2025'
}, {
  orderNum: '66868',
  status: 'Processed',
  transNum: '66868',
  qty: 1,
  product: 'Avoid The Oops: Contract Smarts for Agents',
  price: '$19.95',
  total: '$0.00',
  date: '07/02/2025'
}, {
  orderNum: '67210',
  status: 'Processed',
  transNum: '67210',
  qty: 1,
  product: 'The Bottom Line of Disclosure',
  price: '$19.95',
  total: '$0.00',
  date: '07/27/2025'
}, {
  orderNum: '68856',
  status: 'Processed',
  transNum: '68856',
  qty: 1,
  product: 'Mastering Agency Agreements',
  price: '$19.95',
  total: '$0.00',
  date: '11/09/2025'
}];
export function OrderHistory() {
  const [searchPeriod, setSearchPeriod] = useState('Today');
  return <div className="space-y-4" data-id="element-2245">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2246">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2247">
          Order History
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2248">
          View and search your past purchases.
        </p>
      </div>
      {/* Search bar */}
      <div className="flex items-center gap-2" data-id="element-2249">
        <span className="text-sm text-slate-700" data-id="element-2250">Search For Orders</span>
        <select value={searchPeriod} onChange={e => setSearchPeriod(e.target.value)} className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-2251">
          {['Today', 'Last 7 Days', 'Last 30 Days', 'Last 90 Days', 'Last Year', 'All'].map(p => <option key={p} data-id="element-2252">{p}</option>)}
        </select>
        <button className="px-3 py-1 text-sm border border-slate-300 bg-slate-100 hover:bg-slate-200 rounded transition-colors" data-id="element-2253">
          Search
        </button>
      </div>

      {/* Orders table */}
      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2254">
        <div className="overflow-x-auto" data-id="element-2255">
          <table className="w-full text-xs text-left" data-id="element-2256">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-2257">
              <tr data-id="element-2258">
                <th className="px-3 py-2.5 border-r border-purple-700 w-20" data-id="element-2259">
                  Order Number
                </th>
                <th className="px-3 py-2.5 border-r border-purple-700 w-24" data-id="element-2260">
                  Status
                </th>
                <th className="px-3 py-2.5 border-r border-purple-700 w-16 text-center" data-id="element-2261">
                  Quantity
                </th>
                <th className="px-3 py-2.5 border-r border-purple-700" data-id="element-2262">
                  Packages/Classes
                </th>
                <th className="px-3 py-2.5 border-r border-purple-700 w-16 text-center" data-id="element-2263">
                  Price
                </th>
                <th className="px-3 py-2.5 border-r border-purple-700 w-16 text-center" data-id="element-2264">
                  Total
                </th>
                <th className="px-3 py-2.5 w-24 text-center" data-id="element-2265">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-2266">
              {orders.map((order, i) => <tr key={i} className={`hover:bg-purple-50/20 ${order.status === 'Failed' ? 'bg-red-50' : ''}`} data-id="element-2267">
                  <td className="px-3 py-1.5 border-r border-slate-200 text-slate-700" data-id="element-2268">
                    {order.orderNum}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200" data-id="element-2269">
                    <span className={`${order.status === 'Failed' ? 'text-red-600 font-medium' : 'text-slate-700'}`} data-id="element-2270">
                      {order.status}
                    </span>
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-center text-slate-700" data-id="element-2271">
                    {order.qty}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-slate-800" data-id="element-2272">
                    {order.product}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-center text-slate-700" data-id="element-2273">
                    {order.price}
                  </td>
                  <td className="px-3 py-1.5 border-r border-slate-200 text-center text-slate-700" data-id="element-2274">
                    {order.total}
                  </td>
                  <td className="px-3 py-1.5 text-center text-slate-700" data-id="element-2275">
                    {order.date}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}